import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import {
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  timelineItemClasses,
  TimelineSeparator,
} from '@mui/lab';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Button,
  Grid,
  IconButton,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import Countdown from 'react-countdown';

import BusinessTaxSubMenu from '@/components/nav/BusinessTaxSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import ExitPopup1065 from '@/components/ui/ExitPopup1065';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';

// import Form1065 from '../resources/tax-extension/form-7004-for-form-1065';

const Form1065 = () => {
  const [open, setOpen] = useState(false);
  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Don't miss your payroll tax return deadline.`,
  //   SubHeading:
  //     'E-file Form 940 for easy compliance. File now and save time and stress.',
  //   CtaText: 'E-file Form 940 Now',
  //   CtaSubHeading: `Stay tax compliant with the IRS`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };
  // const [scrollIndex, setScrollIndex] = useState(0);
  const [closeSticky, setCloseSticky] = useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  // const [progress, setProgress] = useState(0);
  const handleStickyClose = (): void => {
    setCloseSticky(true);
  };
  const images = [
    <img
      src="/assets/images/f1065-partnership-img.webp"
      key="first"
      alt="Partnership Details"
      id="loading1"
      className="details-images"
    />,
    <img
      src="/assets/images/f1065-income-img.webp"
      key="second"
      alt="Income and Expenses"
      className="details-images"
    />,
    <img
      src="/assets/images/f1065-partner-information-img.webp"
      key="third"
      alt="Partner Information"
      className="details-images"
    />,
    <img
      src="/assets/images/f1065-k1-allocation-img.webp"
      key="fourth"
      alt="K-1 Allocations"
      className="details-images"
    />,
    <img
      src="/assets/images/f1065-balance-sheet-img.webp"
      key="fifth"
      alt="Balance Sheet Details"
      className="details-images"
    />,
  ];
  const loader = ['loading1', 'loading2', 'loading3', 'loading4', 'loading5'];
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (currentIndex === images.length - 1) {
        setCurrentIndex(0);
      } else {
        setCurrentIndex(currentIndex + 1);
      }
    }, 10000);

    return () => clearInterval(intervalId);
  }, [currentIndex + 1]);
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (currentIndex === loader.length - 1) {
        setCurrentIndex(0);
      } else {
        setCurrentIndex(currentIndex + 1);
      }
    }, 10000);

    return () => clearInterval(intervalId);
  }, [currentIndex + 1]);

  // refs
  // const leftScrollRef = useRef(null)s; // the scrollable container
  const sectionsRef = useRef<any>([]); // array of section elements

  // state for which image to show
  const [scrollIndex, setScrollIndex] = useState(0);

  // example images (replace these paths with your real images)
  const images1 = [
    '/assets/images/domestic-partner-img.webp',
    '/assets/images/foreign-partner-img.webp',
    '/assets/images/exception-img.webp',
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const target = entry.target as HTMLElement;
            const index = Number(target.dataset.index);
            setScrollIndex(index);
          }
        });
      },
      {
        threshold: 0.6, // observe viewport, not left container
      }
    );

    sectionsRef.current.forEach((sec: HTMLElement) => {
      if (sec) observer.observe(sec);
    });

    return () => observer.disconnect();
  }, []);
  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 9, 15));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 9, 15)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);

  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Days</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };
  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="E-file IRS Form 1065 Online for 2025 | TaxZerone"
          description="File IRS Form 1065 online for your partnership with TaxZerone. IRS-authorized, accurate K-1 delivery, and transparent pricing. Start filing now."
          keywords=""
          canonical="business-tax/efile-irs-form-1065-online/"
          jsonLdPricing=""
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount=""
          ogShareImg=""
        />
      }
    >
      <Hidden smDown>
        {!closeSticky && (
          <Box
            sx={{
              position: 'fixed',
              bottom: 0,
              width: '100%',
              left: 0,
              right: 0,
              zIndex: 3,
            }}
          >
            <Container
              maxWidth="md"
              sx={{
                backgroundColor: '#fff',
                mx: { xs: 3, lg: 'auto' },
                width: 'auto',
                py: 1.5,
                borderTopLeftRadius: 6,
                borderTopRightRadius: 6,
                boxShadow: '0 0 20px rgba(0,0,0,.5)',
                position: 'relative',
                borderWidth: 2,
                borderColor: '#414042',
                borderStyle: 'solid',
                borderBottom: 'none',
              }}
            >
              <Tooltip title="Close" arrow placement="top">
                <IconButton
                  aria-label="close"
                  size="small"
                  onClick={handleStickyClose}
                  sx={{
                    position: 'absolute',
                    right: -12,
                    top: -12,
                    color: '#fff',
                    backgroundColor: '#e11d1d',
                    '&:hover, &:focus': {
                      backgroundColor: '#b01919',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={{ xs: 1, sm: 1, md: 2 }}
                sx={{ justifyContent: 'space-between', alignItems: 'center' }}
              >
                <Box>
                  <Typography
                    component="div"
                    variant="body1"
                    sx={{
                      textAlign: { xs: 'center', sm: 'left' },
                      fontSize: { xs: 15, sm: 17, md: 18, lg: '1.25rem' },
                      //  color: '#ccc',
                      lineHeight: 1.3,
                    }}
                  >
                    <strong>Thank you</strong> for trusting{' '}
                    <b style={{ fontWeight: 600, color: '#213e99' }}>
                      TaxZerone
                    </b>{' '}
                    with your <strong> Form 1065</strong> filing.
                  </Typography>
                </Box>
                {/* <Stack direction="row" alignItems="center" spacing={2}>
                  <Countdown date={lastDayTaxSeason} renderer={renderer} />
                  <Hidden mdUp>
                    <Box sx={{ textAlign: 'center' }}>
                      <Button
                        variant="contained"
                        size="medium"
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
                        sx={{
                          textTransform: 'none',
                          px: 2.5,
                          display: 'inline-block',
                          boxShadow: 'none',
                          borderRadius: 4.2,
                          backgroundColor: '#213e99',
                          whiteSpace: 'nowrap',
                          '&:hover, &:focus': {
                            backgroundColor: '#172b6b',
                          },
                        }}
                      >
                        E-File Now
                      </Button>
                    </Box>
                  </Hidden>
                </Stack>
                <Hidden mdDown>
                  <Box sx={{ textAlign: 'center' }}>
                    <Button
                      variant="contained"
                      size="medium"
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
                      sx={{
                        textTransform: 'none',
                        px: 2.5,
                        display: 'inline-block',
                        boxShadow: 'none',
                        borderRadius: 4.2,
                        backgroundColor: '#213e99',
                        whiteSpace: 'nowrap',
                        '&:hover, &:focus': {
                          backgroundColor: '#172b6b',
                        },
                      }}
                    >
                      E-File Now
                    </Button>
                  </Box>
                </Hidden> */}
              </Stack>
            </Container>
          </Box>
        )}
      </Hidden>
      <BusinessTaxSubMenu />
      <ExitPopup1065 />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
        component="section"
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #1f6666, #106ad2)',
            p: 1.5,
            px: 4,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              variant="body1"
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: 16, sm: 17, md: 20, lg: '1.28rem' },
                color: '#d9d9d9',
              }}
            >
              <strong style={{ fontWeight: 600 }}>
                📢Attention Partnerships!
              </strong>{' '}
              E-file Your{' '}
              <span style={{ fontWeight: 600, color: '#ffbb00' }}>
                {' '}
                2025 Form 1065
              </span>{' '}
              online and securely deliver Schedule K-1s to partners.
            </Typography>
            <Box sx={{}}>
              {/* <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time left to file before the deadline{' '}
                <Hidden smUp>
                  <br />
                </Hidden>
                (
                <span style={{ fontWeight: 600, color: '#fff' }}>
                  sept 15, 2026
                </span>
                ):
              </Typography> */}
              <Countdown date={lastDayTaxSeason} renderer={renderer} />
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
                sx={{
                  backgroundColor: '#ee4266',
                  '&:hover, &:focus': {
                    backgroundColor: '#8338ec',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#fff',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: 18,
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-file Now!
              </Button>
              {/* <Typography
                variant="body2"
                sx={{ textAlign: 'center', mt: 1, color: '#fff' }}
              >
                {' '}
                <b style={{ color: '#fff' }}> Save 10%</b> with code{' '}
                <b style={{ color: '#f4d58d' }}> TZOTE10</b>
              </Typography> */}
            </Box>
          </Stack>
        </Box>
      </Container>

      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="header"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                File IRS{' '}
                <span className="highlight-container">
                  <span className="highlight">Form 1065</span>
                </span>{' '}
                Online for the 2025 Tax Year
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                E-file your partnership’s income tax return with ease. TaxZerone
                provides a secure and accurate platform for filing Form 1065
                online, whether you operate a domestic partnership or a{' '}
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>
                multi-member LLC taxed as a partnership.
              </Typography>

              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    mr: { xs: 0, md: 4 },
                    mb: { xs: 2, sm: 0 },
                  }}
                >
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
                  >
                    File Form 1065
                  </Button>
                  {/* <Typography
                    variant="body2"
                    sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                  >
                    Takes 3 steps and less than 5 minutes
                  </Typography> */}
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
              <Box
                sx={{
                  position: 'relative',
                  maxWidth: 580,
                  mx: { xs: 'auto', md: 0 },
                  mt: 5,
                }}
              />
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/f1065-landing-img.webp"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <source
                  srcSet="/assets/images/f1065-landing-img.png"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <img
                  src="/assets/images/f1065-landing-img.png"
                  alt="File IRS Form 1065 Online for the 2025 Tax Year"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/f1065-landing-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/f1065-landing-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/f1065-landing-img-sm.png"
                  alt="File IRS Form 1065 Online for the 2025 Tax Year"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                File Form 1065 Online for just{' '}
                <Box
                  component="strong"
                  sx={{
                    color: '#ffe400',
                    fontSize: { xs: 24, sm: 30 },
                  }}
                >
                  $179.99{' '}
                </Box>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 17, md: 17, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 1,
                  textAlign: 'left',
                }}
              >
                One flat fee. No hidden charges. Your complete 1065 e-filing
                includes Schedule K-1 generation for all partners.
              </Typography>
            </Box>
            {/* <Typography variant="body1">Add-on services:</Typography>
              <Box component={'ul'} sx={{ mt: -0.1 }}>
                <li>
                  Postal K-1 Delivery:{' '}
                  <Box
                    component={'strong'}
                    sx={{
                      color: '#ffffffff',
                      fontSize: { xs: 24, sm: 24 },
                    }}
                  >
                    $1.75
                  </Box>{' '}
                  per recipient
                </li>
                <li>
                  {' '}
                  ZeroneVault Digital Delivery: Postal K-1 Delivery:{' '}
                  <Box
                    component={'strong'}
                    sx={{
                      color: '#fffad1ff',
                      fontSize: { xs: 24, sm: 24 },
                    }}
                  >
                    $0.50
                  </Box>{' '}
                  per recipient{' '}
                </li>
              </Box> */}

            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 150 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Button
                size="large"
                variant="contained"
                href="/pricing/#businesstax"
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#fff',
                  color: '#0a7581',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#172b6b',
                  },
                }}
              >
                See Pricing
              </Button>
            </Box>
          </Stack>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          pb: 6,
          pt: 1,
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6, sm: 12 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                // sx={{
                //   display: 'flex',
                //   justifyContent: 'center',
                //   alignItems: 'center',
                //   height: '100%',
                //   textAlign: { xs: 'center', md: 'right' },
                //   my: { xs: 3, md: 0 },
                // }}
                className="image-container"
              >
                <Box
                  component={motion.div}
                  key={currentIndex}
                  className="image-fade"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 1.5, ease: 'easeInOut' }}
                  sx={{
                    '& img': {
                      width: '100% !important',
                      height: { xs: 'auto', md: 480 },
                    },
                  }}
                >
                  {images[currentIndex]}
                </Box>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: 2,
                  }}
                >
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#e791c66f',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 0 ? 'loading-effect' : ''}
                    id="loading1"
                  />{' '}
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#e791c66f',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 1 ? 'loading-effect' : ''}
                    id="loading2"
                  />
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#e791c66f',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 2 ? 'loading-effect' : ''}
                    id="loading3"
                  />
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#e791c66f',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 3 ? 'loading-effect' : ''}
                    id="loading4"
                  />
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#e791c66f',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 4 ? 'loading-effect' : ''}
                    id="loading5"
                  />
                </Stack>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6, sm: 12 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box sx={{ ml: { md: 3, xs: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,
                    mb: 2,
                    textAlign: 'center',
                  }}
                >
                  What You’ll Need to File Form 1065
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, ml: 3.5 }}>
                  To file IRS Form 1065 through TaxZerone, ensure you have the
                  following:{' '}
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 5 },
                    mt: { xs: 0, md: 4 },
                    mb: { xs: 0, md: 3 },
                    '& li': { display: 'flex', mb: 2 },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Partnership Details:
                      </span>{' '}
                      Legal name, EIN, business address, date the partnership
                      began
                    </Box>
                  </li>
                  <li>
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Income and Expenses:
                      </span>{' '}
                      Gross receipts, cost of goods sold, operating expenses,
                      and applicable credits
                    </Box>
                  </li>
                  <li>
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Partner Information:
                      </span>{' '}
                      Name, TIN, percentage ownership, and distributions for
                      each partner
                    </Box>
                  </li>
                  <li>
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        K-1 Allocations:{' '}
                      </span>{' '}
                      Profit, loss, and capital allocations to every partner
                    </Box>
                  </li>
                  <li>
                    {' '}
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Balance Sheet Details:{' '}
                      </span>
                      Beginning and ending assets, liabilities, and capital
                      accounts
                    </Box>
                  </li>{' '}
                </Box>

                <Typography variant="body1" sx={{ ml: 3.2, mt: 2 }}>
                  Filing again next year? TaxZerone securely stores your past
                  filings so you can reuse partnership and partner details for
                  faster filing.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={{ xs: 12, md: 5.5, sm: 12, lg: 5 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Eligibility Checklist: Is Form 1065 Right for Your Business?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, fontWeight: 600 }}>
                  Before you file, make sure your business qualifies:
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 3 },
                    mt: { xs: 0, md: 3 },
                    mb: { xs: 0, md: 3 },
                    '& li': { display: 'flex' },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      {' '}
                      Your business is a{' '}
                      <span style={{ fontWeight: 600 }}>
                        domestic partnership
                      </span>{' '}
                      or <br />
                      <span style={{ fontWeight: 600 }}>
                        multi-member LLC
                      </span>{' '}
                      taxed as a partnership.
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      You have{' '}
                      <span style={{ fontWeight: 600 }}>
                        income, gains, losses, deductions, or credits
                      </span>{' '}
                      to report from business activities.
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      You have{' '}
                      <span style={{ fontWeight: 600 }}>
                        two or more partners
                      </span>{' '}
                      (individuals, corporations, LLCs, or other entities).
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      The entity is{' '}
                      <span style={{ fontWeight: 600 }}>not taxed</span> as a{' '}
                      <span style={{ fontWeight: 600 }}>
                        C corporation or S corporation
                      </span>{' '}
                      for federal income tax purposes.
                    </Box>
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If your business meets these criteria, you are generally
                  required to file IRS Tax Form 1065 to report the partnership’s
                  income and issue Schedule K-1s to partners for their
                  individual or entity returns.
                </Typography>
                <Box sx={{ textAlign: { xs: 'center', md: 'left' }, mt: 3 }}>
                  <Typography
                    variant="body1"
                    sx={{ mx: { xs: 0, sm: 15 }, fontWeight: 600 }}
                  >
                    Still Unsure?{' '}
                  </Typography>
                  <Button
                    variant="contained"
                    sx={{
                      mt: 0.5,
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    className="btn-primary"
                    // href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
                    href="/contact-us/"
                  >
                    Contact Our Support
                  </Button>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6.5, sm: 12, lg: 7 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/f1065-eligibility-img.webp" />
                  <source srcSet="/assets/images/f1065-eligibility-img.png" />
                  <img
                    src="/assets/images/f1065-eligibility-img.png"
                    alt="Eligibility Checklist: Is Form 1065 Right for Your Business?"
                    className="img-responsive"
                    loading="lazy"
                    width={550}
                    height={400}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Grid size={12}>
          <Container maxWidth="lg" sx={{ mt: 4 }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: { xs: 0, sm: 3 },
                mt: 4,
                textAlign: 'center',
              }}
            >
              Who Must File Form 1065?
            </Typography>
          </Container>
          <Container
            maxWidth="lg"
            sx={{
              display: 'flex',
              flexDirection: 'row',
              // gridGap: 2,
              // gridTemplateColumns: 'repeat(2, 1fr)',
              // m: 'atuo',
              position: 'relative',
              // width: '100%',
              // rowGap: 10,
              // maxWidth: 1152,
            }}
          >
            {/* LEFT SIDE — uses NORMAL PAGE SCROLL */}
            <Box
              component="div"
              sx={{
                width: { xs: '100%', sm: '100%', md: '50%' },
                padding: { xs: 0, sm: '1rem' },
                top: { lg: 40, md: 50, sm: 60, xs: 0 },
                gridColumn: 2,
              }}
            >
              {/* Section 0 */}
              <Box
                ref={(el) => {
                  if (el) sectionsRef.current[0] = el;
                }}
                data-index="0"
                sx={{
                  p: 3,
                  minHeight: { xs: 0, md: '77vh', lg: '70vh' },
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'left',
                  m: '0',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 20, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 2,
                    textAlign: 'left !important',
                    width: '100%',
                  }}
                >
                  {' '}
                  Domestic Partnerships{' '}
                </Typography>{' '}
                <Typography variant="body1">
                  {' '}
                  Every domestic partnership is generally required to file Form
                  1065, U.S. Return of Partnership Income, unless it has no
                  income, deductions, or credits to report for the tax year.
                  This includes partnerships formed under state law and
                  multi-member LLCs classified as partnerships for federal tax
                  purposes.{' '}
                </Typography>
              </Box>
              {/* Section 1 */}
              <Box
                ref={(el) => {
                  if (el) {
                    sectionsRef.current[1] = el;
                  }
                }}
                data-index="1"
                sx={{ p: 3, minHeight: { xs: 0, md: '60vh' } }}
              >
                {' '}
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 20, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  {' '}
                  Foreign Partnerships{' '}
                </Typography>{' '}
                <Typography variant="body1">
                  {' '}
                  Foreign partnerships must file Form 1065 if they have income
                  effectively connected with a U.S. trade or business or have
                  U.S. source income. Filing is required even if the
                  partnership’s main operations are outside the U.S. or if all
                  partners are foreign persons.{' '}
                </Typography>
              </Box>

              <Box
                ref={(el) => {
                  if (el) {
                    sectionsRef.current[2] = el;
                  }
                }}
                data-index="2"
                sx={{ p: 3, minHeight: { xs: 0, md: '50vh' } }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 20, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  {' '}
                  Exceptions for Foreign Partnerships:{' '}
                </Typography>{' '}
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  {' '}
                  <li>
                    {' '}
                    A foreign partnership with U.S. partners is not required to
                    file if it had no effectively connected income, U.S. source
                    income of $20,000 or less.{' '}
                  </li>{' '}
                  <li>
                    {' '}
                    Less than 1% of partnership items attributable to U.S.
                    partners, and it does not meet withholding partnership
                    definitions.{' '}
                  </li>{' '}
                  <li>
                    {' '}
                    Foreign partnerships without any U.S. partners and no
                    effectively connected income generally do not have to file
                    the 1065 Form IRS return.{' '}
                  </li>{' '}
                </Box>
              </Box>
            </Box>
            <Hidden mdDown>
              {/* RIGHT SIDE — sticky image */}
              <Box
                component="div"
                sx={{
                  width: '50%',
                  position: 'sticky',
                  top: { md: 90 },
                  height: { sm: '8vh', md: '100vh', lg: '68vh' },
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'transparent',
                  transition: 'all 0.3s ease-out',
                }}
              >
                <img
                  src={images1[scrollIndex]}
                  alt="visual"
                  style={{
                    width: '80%',
                    height: 'auto',
                    borderRadius: 12,
                    animation: 'fadeIn 0.9s ease-in-out',
                  }}
                />
              </Box>
            </Hidden>
          </Container>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to E-file Form 1065 with TaxZerone
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing your Form 1065 is quick and streamlined—just follow these
                steps:
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            sx={{ justifyContent: 'center', alignItems: 'center' }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/1065-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/1065-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/1065-steps-img.png"
                  alt="How to E-file Form 1065 with TaxZerone"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Enter Partnership Details"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Enter Partnership Details
                    </Typography>
                    <Typography variant="body1">
                      Choose Form 1065 after login and enter partnership and
                      partner details using our intuitive interface.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Add Income, Deductions & Balance Sheet"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Add Income, Deductions & Balance Sheet
                    </Typography>
                    <Typography variant="body1">
                      Enter business income, deductions, and other tax items
                      while automatically creating K-1s for each partner.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Validate & E-file"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Validate & E-file
                    </Typography>
                    <Typography variant="body1">
                      Run built-in checks to confirm that your return is
                      complete and compliant with IRS rules, then transmit
                      electronically.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-4-icon.webp" />
                        <source srcSet="/assets/images/step-4-icon.png" />
                        <img
                          src="/assets/images/step-4-icon.png"
                          alt="Distribute K-1s to Partners"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Distribute K-1s to Partners
                    </Typography>
                    <Typography variant="body1">
                      After acceptance, deliver K-1s digitally via ZeroneVault
                      or send by mail using our add-on services.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>
              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
                >
                  E-file 1065 Now
                </Button>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why Choose TaxZerone for Form 1065 E-filing?
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            m={2}
            mt={4}
            pb={{ xs: 0, sm: 4, md: 7 }}
            sx={{ justifyContent: 'center', p: 0, listStyleType: 'none' }}
            component="ul"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="Trusted IRS E-file Provider"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Trusted IRS E-file Provider
                </Typography>
                <Typography variant="body1">
                  File your partnership return on a reliable, IRS-compliant
                  platform that ensures smooth processing.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Guided Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Guided Filing
                </Typography>
                <Typography variant="body1">
                  Step-by-step screens guide you through each part of Form 1065
                  and associated schedules, following the IRS{' '}
                  <Link
                    href="/resources/business-tax/form-1065-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 1065 instructions
                  </Link>
                  .
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/auto-genert-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/auto-genert-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/auto-genert-icon.png"
                      alt="K-1 Auto-Generation"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  K-1 Auto-Generation
                </Typography>
                <Typography variant="body1">
                  Generate irs tax form 1065 Schedule k 1 for every partner and
                  support electronic and postal delivery.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12} component="li">
                &nbsp;
              </Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/fast-filing-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/fast-filing-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/fast-filing-icon.png"
                      alt="Quick Repeat Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Quick Repeat Filing
                </Typography>
                <Typography variant="body1">
                  Reuse prior-year data for returning partnerships to accelerate
                  setup and reduce data entry.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/error-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/error-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/error-icon.png"
                      alt="Advanced Error Checks "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Advanced Error Checks
                </Typography>
                <Typography variant="body1">
                  Automatic validation helps identify missing TINs, inconsistent
                  totals, and other common 1065 errors.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Transparent Pricing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Transparent Pricing
                </Typography>
                <Typography variant="body1">
                  No surprise fees—just a clear base price and optional add-ons
                  that scale with your needs.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={10}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'row', md: 'row' } }}
          >
            <Grid size={12}>
              <Box
                sx={{
                  mb: { xs: 0, md: 5 },
                  mt: { xs: 0, md: 5 },
                  textAlign: 'center',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Filing Form 1065 Made Simple for Partnerships &{' '}
                  <Hidden smDown>
                    <br />
                  </Hidden>
                  First-Time Filers
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Starting or managing a partnership comes with important tax
                  responsibilities,{' '}
                  <Hidden smDown>
                    {' '}
                    <br />
                  </Hidden>
                  but filing your first{' '}
                  <Link
                    href="/resources/business-tax/form-1065-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    form 1065 irs
                  </Link>{' '}
                  is easier than you think. TaxZerone streamlines the process{' '}
                  <Hidden smDown>
                    {' '}
                    <br />
                  </Hidden>
                  so you can focus on running your business instead of decoding
                  IRS forms.
                </Typography>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6, sm: 12, lg: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  borderRadius: 4,
                  minHeight: '100%',
                  backgroundColor: '#ffffffff',
                  border: 'none',
                }}
              >
                <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 22, md: 20, sm: 18, xs: 18 },
                      fontWeight: 600,
                      mb: 3,
                    }}
                  >
                    Why This Matters for Partnerships
                  </Typography>

                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 3 },
                      mt: { xs: 0, md: 3 },
                      mb: { xs: 0, md: 3 },
                      '& li': { display: 'flex' },
                    }}
                  >
                    {' '}
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Straightforward Pricing:
                        </span>{' '}
                        A single flat fee with clear add-ons, ideal for
                        partnerships of all sizes and budget-conscious
                        businesses.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Step-by-Step Guidance:
                        </span>{' '}
                        The platform walks you through each section of Form 1065
                        using plain language.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Automatic K-1 Generation:
                        </span>{' '}
                        Instantly generate and prepare Schedule K-1s for all
                        partners.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Error-Reduced Filing:
                        </span>{' '}
                        Built-in checks help you avoid common mistakes that
                        could trigger delays or notices.
                      </Box>
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6, sm: 12, lg: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  borderRadius: 4,
                  minHeight: '100%',
                  backgroundColor: '#ccd5ae',
                  border: 'none',
                }}
              >
                <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 22, md: 20, sm: 18, xs: 18 },
                      fontWeight: 600,
                      mb: 3,
                    }}
                  >
                    First-Time Filers Get Extra Peace of Mind
                  </Typography>

                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 3 },
                      mt: { xs: 0, md: 3 },
                      mb: { xs: 0, md: 3 },
                      '& li': { display: 'flex' },
                    }}
                  >
                    {' '}
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Clear Explanations at Every Step:
                        </span>{' '}
                        Complex partnership tax concepts are simplified with
                        easy-to-follow prompts.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Dedicated Support Team:
                        </span>{' '}
                        Dedicated Support Team:
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          Beginner-Friendly Interface:
                        </span>{' '}
                        A clean, intuitive layout helps first-time filers move
                        through Form 1065 with confidence, without feeling
                        overwhelmed.{' '}
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          Save & Resume Anytime:
                        </span>{' '}
                        Start your return now and pick it up later without
                        losing progress—perfect when you’re still gathering
                        partner or financial details.{' '}
                      </Box>
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid size={12}>
              <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  //

                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
                >
                  Start Filing Now
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6, sm: 12 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/1120s-tax-professional-img.webp" />
                  <source srcSet="/assets/images/1120s-tax-professional-img.png" />
                  <img
                    src="/assets/images/1120s-tax-professional-img.png"
                    alt="Special Pricing for CPAs & Tax Professionals"
                    className="img-responsive"
                    loading="lazy"
                    width={450}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6, sm: 12 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                  }}
                >
                  Special Pricing for CPAs & Tax Professionals
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                  Handling multiple partnership returns? Enjoy volume savings
                  and additional support.
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li> Bigger filing volume means better discounts. </li>
                  <li>
                    Save time with reusable business and partner profiles.{' '}
                  </li>
                  <li>
                    Get white-glove onboarding and priority support during peak
                    season.{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mt: 2 }}>
                  📞{' '}
                  <Link
                    // href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
                    href="/contact-us/"
                    sx={{ color: '#0202ff' }}
                  >
                    Contact Us Now
                  </Link>{' '}
                  to unlock your custom CPA pricing and streamline partnership
                  filings.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'row', md: 'row' } }}
          >
            <Grid
              size={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'center',
                  md: 'center',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Form 1065 Filing Deadlines – 2025 Tax Year
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  These deadlines apply if your partnership uses a
                  <span style={{ fontWeight: 600 }}> calendar year</span> (Jan 1
                  – Dec 31).
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Filing Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Deadline
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{ backgroundColor: '#fff' }}>
                          <TableCell>File with IRS (E-file) </TableCell>
                          <TableCell>March 16, 2026</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Partner K-1 Distribution </TableCell>
                          <TableCell>March 16, 2026 </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#fff' }}>
                          <TableCell>
                            With Extension (
                            <Link
                              href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 7004
                            </Link>
                            ){' '}
                          </TableCell>
                          <TableCell>September 15, 2026</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Alert severity="warning" icon={false} sx={{ mb: 0 }}>
                  <b>Note:</b> If a deadline falls on a weekend or legal
                  holiday, it generally moves to the next business day.
                </Alert>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 8, sm: 12, lg: 8.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 3,
                  minHeight: '100%',
                  backgroundColor: '#f2e9e4',
                }}
                className="pattern-bg"
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { md: 22, sm: 20, xs: 18 },
                    mb: 1,
                    fontWeight: 600,
                  }}
                >
                  For Fiscal-Year Partnerships{' '}
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  If your partnership uses a fiscal year, the Form 1065 due date
                  is:
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The 15th day of the 3rd month after the fiscal year ends.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  Examples:
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Fiscal year ending June 30, 2026 → Form 1065 due{' '}
                  <span style={{ fontWeight: 600 }}> September 15, 2026</span>.
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Fiscal year ending September 30, 2026 → Form 1065 due{' '}
                  <span style={{ fontWeight: 600 }}>December 15, 2026</span>.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, md: 4, sm: 12, lg: 3.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 3,
                  minHeight: '100%',
                  backgroundColor: '#fff0f3',
                }}
                className="pattern-bg"
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { md: 22, sm: 20, xs: 18 },
                    mb: 1,
                    fontWeight: 600,
                  }}
                >
                  Need more time to file Form 1065?
                </Typography>
                <Typography variant="body1">
                  You can request a{' '}
                  <span style={{ fontWeight: 600 }}> Form 1065 extension</span>{' '}
                  by{' '}
                  <Link
                    href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    e-filing Form 7004
                  </Link>{' '}
                  on or before the original due date. This provides{' '}
                  <span style={{ fontWeight: 600 }}>
                    an automatic 6-month extension
                  </span>{' '}
                  to file your return.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6, sm: 12 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/1120s-penalties-late-img.webp" />
                  <source srcSet="/assets/images/1120s-penalties-late-img.png" />
                  <img
                    src="/assets/images/1120s-penalties-late-img.png"
                    alt="Penalties for Late or Inaccurate Filing"
                    className="img-responsive"
                    loading="lazy"
                    width={450}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6, sm: 12 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                  }}
                >
                  Penalties for Late or Inaccurate Filing
                </Typography>

                <Typography variant="body1" sx={{ mt: 2, fontWeight: 600 }}>
                  Avoid penalties by filing a complete and accurate return on
                  time.
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Late filing may trigger per-partner monthly penalties,
                    </span>{' '}
                    up to a maximum number of months set by the IRS.
                  </li>
                  <li>
                    If tax is owed,{' '}
                    <span style={{ fontWeight: 600 }}>
                      additional percentage-based penalties and interest may
                      apply
                    </span>{' '}
                    until the balance is paid.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Incomplete, late, or incorrect Schedule K-1s can also
                      result in separate penalties per K-1.
                    </span>
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mt: 2 }}>
                  If you are unsure, contact a CPA or{' '}
                  <Link
                    // href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
                    href="/contact-us/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    our support team
                  </Link>{' '}
                  to help you reduce the risk of errors and penalties.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid size={12}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 3,
                  border: 'none',
                  maxWidth: 950,
                  m: 'auto',
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 2,
                    textAlign: 'center',
                  }}
                >
                  Common Mistakes to Avoid
                </Typography>

                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  {' '}
                  <li>
                    Not reconciling partner capital accounts and balance sheet
                    totals.
                  </li>
                  <li>
                    Omitting or misreporting guaranteed payments to partners.
                  </li>
                  <li>
                    Using incorrect ownership percentages when allocating income
                    or loss on K-1s.{' '}
                  </li>
                  <li>Missing K-1 delivery deadlines to partners. </li>
                  <li>
                    Not applying the correct codes for various income,
                    deductions, and credits on Schedule K.{' '}
                  </li>
                </Box>

                <Alert severity="info" id="whatare" icon={false} sx={{ mb: 1 }}>
                  <b>Tips:</b> TaxZerone highlights common 1065 errors before
                  you submit your return.
                </Alert>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Ready to E-file IRS Form 1065?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Avoid penalties, save time, and stay compliant—file your partnership
          return securely with TaxZerone.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
          >
            Start Filing Form 1065 Now
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg" component="section" aria-labelledby="1065-faqs">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, md: 9, sm: 10 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              id="1065-faqs"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What is IRS Form 1065?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="p" sx={{ mt: 1 }}>
                      Form 1065 is the U.S. return used by partnerships to
                      report income, deductions, credits, and other tax items,
                      and to pass those amounts through to partners via Schedule
                      K-1.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What are pass-through entities?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="p" sx={{ mt: 1 }}>
                      Pass-through entities are business structures like
                      partnerships or multi-member LLCs that do not pay federal
                      income tax at the entity level. Instead, the income or
                      losses pass through directly to the owners, who report
                      them on their personal or business tax returns. Form 1065
                      is the tax form used to report this income to the IRS.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What is the difference between Schedule K-1 and Form 1065?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="p" itemProp="text" sx={{ mt: 1 }}>
                    Form 1065 is the partnership&apos;s overall tax return,
                    reporting total income, deductions, and credits. Schedule
                    K-1 is a detailed statement issued to each partner, showing
                    their specific share of the partnership’s income,
                    deductions, and credits, which they use to complete their
                    individual tax returns.
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What is the purpose of Schedule K-1 for a partnership?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="p" sx={{ mt: 1 }}>
                      <Link
                        href="https://www.irs.gov/instructions/i1065sk1"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Schedule k 1 form 1065 irs
                      </Link>{' '}
                      reports each partner’s share of partnership income,
                      deductions, credits, and other items so partners can
                      include them on their own tax returns.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Is my LLC automatically required to file Form 1065?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="p" itemProp="text" sx={{ mt: 1 }}>
                    By default, a multi-member LLC is usually treated as a
                    partnership and may need to file Form 1065, while a
                    single-member LLC is generally disregarded and files on the
                    owner’s return unless it elects a different classification.
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Can Form 1065 be e-filed?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="p" itemProp="text" sx={{ mt: 1 }}>
                    Yes, the IRS strongly encourages e-filing. Partnerships
                    filing a certain number of returns or with more than 100
                    partners are generally required to file electronically
                    according to the{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      IRS Tax Form 1065 instructions
                    </span>
                    .
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What happens if I file Form 1065 late?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="p" itemProp="text" sx={{ mt: 1 }}>
                    Late or incomplete filing can lead to per-partner penalties,
                    additional charges on unpaid tax, and separate penalties for
                    late or incorrect K-1s.
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Do partners still need to file individual returns if a Form
                  1065 is filed?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="p" itemProp="text" sx={{ mt: 1 }}>
                    Yes. When the IRS 1065 Form is filed, partners must use the
                    information from their Schedule K-1 to report their share of
                    partnership income, deductions, and credits on their
                    individual federal and, if applicable, state tax returns.
                  </Typography>
                </Box>
              </Box>
              <Alert severity="info" icon={false} sx={{ borderRadius: 2 }}>
                <Accordion
                  // defaultExpanded
                  sx={{
                    '&.MuiAccordion-root::before, &.MuiAccordion-root.Mui-expanded::before':
                      {
                        background: 'none !important',
                      },
                    '&.MuiAccordion-root': { background: 'none !important' },
                    '& .MuiAccordionSummary-content': {
                      fontFamily: 'poppins',
                      fontWeight: 600,
                      color: '#014361',
                      fontSize: 16,
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls=""
                    id=""
                    sx={{
                      px: 0,
                      m: 0,
                      justifyContent: 'flex-start',
                      '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded':
                        { m: '0 !important', flexGrow: 0 },
                    }}
                  >
                    Free Resources Section
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0 }}>
                    <span
                      style={{
                        fontWeight: 600,
                        marginTop: 8,
                        display: 'inline-block',
                      }}
                    >
                      {' '}
                      Add-ons:
                    </span>{' '}
                    <br />
                    <ul>
                      <li style={{ marginBottom: 8 }}>
                        IRS Form 1065 PDF (
                        <Link
                          href="https://www.irs.gov/pub/irs-pdf/f1065.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Download
                        </Link>
                        ){' '}
                      </li>
                      <li style={{ marginBottom: 0 }}>
                        IRS Form 1065 Instructions{' '}
                        <Link
                          href="https://www.irs.gov/pub/irs-pdf/i1065.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Download
                        </Link>{' '}
                      </li>
                    </ul>
                  </AccordionDetails>
                </Accordion>
              </Alert>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form1065;
